import { render, staticRenderFns } from "./CreateClassMenu.vue?vue&type=template&id=05ff9c2a&scoped=true"
import script from "./CreateClassMenu.vue?vue&type=script&lang=js"
export * from "./CreateClassMenu.vue?vue&type=script&lang=js"
import style0 from "./CreateClassMenu.vue?vue&type=style&index=0&id=05ff9c2a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff9c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ff9c2a')) {
      api.createRecord('05ff9c2a', component.options)
    } else {
      api.reload('05ff9c2a', component.options)
    }
    module.hot.accept("./CreateClassMenu.vue?vue&type=template&id=05ff9c2a&scoped=true", function () {
      api.rerender('05ff9c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateClassMenu.vue"
export default component.exports